import api from '@/lib/api'

export default {
  namespaced: true,
  state: {
    recommendedServices: [],
    servicesByCategory: [],
    serviceDetails: {
      companyProfile: [],
      description: [],
      serviceImage: [],
      serviceDetail: []
    }
  },
  mutations: {
    setRecommendedServices(state, services) {
      state.recommendedServices = services;
    },
    setServicesByCategory(state, products) {
      state.servicesByCategory = products;
    },
    setServiceDetails(state, service) {
      state.serviceDetails = service;
    }
  },
  actions: {
    async fetchRecommendedServices({ commit }) {
      const response = await api.getRecommendedServices()
      //console.log('RANDOM SERVICE::::', response);
      commit('setRecommendedServices', response.data.Result)

      var evt = new CustomEvent('owl-initialize', {  });
  		window.dispatchEvent(evt);
    },
    async fetchServicesByCategory({ commit }, { categoryId }) {
      const response = await api.getServicesByCategory(categoryId)
      commit('setServicesByCategory', response.data.Result)
    },
    async fetchServiceDetails({ commit }, { serviceId }) {
      const response = await api.getServiceDetails(serviceId);
      commit('setServiceDetails', {
        companyProfile : response.data.companyProfile,
        description : response.data.description,
        serviceDetail : response.data.serviceDetail,
        serviceImage : response.data.serviceImage,
      })
    }
  }
}
